import Tooltip from 'components/Tooltip';
import React, { FC } from 'react';
import { Placement } from 'react-laag';
import { GreenPlusIcon, IconMinus } from 'static';

import { StyledButton, StyledTooltipWrap } from './styled';

interface PlusButtonProps {
  width?: string;
  contained?: boolean;
  muted?: boolean;
  disabled?: boolean;
  onClick: () => void;
  position?: Placement;
  tooltipStyle?: { [key: string]: string | number };
  text?: JSX.Element | JSX.Element[] | string;
  isVisible?: boolean;
  adjustToolTipPosition?: { [key: string]: string | number };
  isMinusIcon?: boolean;
}

const PlusButton: FC<PlusButtonProps> = ({
  width = '40px',
  contained,
  muted,
  disabled,
  onClick,
  position,
  text,
  isVisible,
  tooltipStyle,
  adjustToolTipPosition,
  isMinusIcon,
}) =>
  text ? (
    <Tooltip
      position={position}
      tooltipStyle={{ ...tooltipStyle }}
      text={text}
      isVisible={isVisible}
      adjustToolTipPosition={adjustToolTipPosition}
    >
      <StyledTooltipWrap>
        <StyledButton
          type="button"
          onClick={onClick}
          contained={contained}
          muted={muted}
          disabled={disabled}
          width={width}
          isMinusIcon={isMinusIcon}
        >
          {isMinusIcon ? (
            <IconMinus width={width} height={width} />
          ) : (
            <GreenPlusIcon width={width} height={width} />
          )}
        </StyledButton>
      </StyledTooltipWrap>
    </Tooltip>
  ) : (
    <StyledButton
      type="button"
      onClick={onClick}
      contained={contained}
      muted={muted}
      disabled={disabled}
      width={width}
      isMinusIcon={isMinusIcon}
    >
      {isMinusIcon ? (
        <IconMinus width={width} height={width} />
      ) : (
        <GreenPlusIcon width={width} height={width} />
      )}
    </StyledButton>
  );

export default PlusButton;
